
import { mapGetters } from 'vuex'
export default {
  name: 'TrustpilotProductReviews',
  props: {
    sku: {
      type: String,
      required: true
    }
  },
  head () {
    return {
      script: [
        {
          type: 'text/javascript',
          src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
          async: true,
          defer: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      countrySpecificInformation: 'storyblok/getCountrySpecificInformation',
    }),
    trustpilotWidgetLanguageCode () {
      return this.countrySpecificInformation?.content?.TrustpilotWidget[0]?.dataLocale || 'en-US'
    },
    countrySpecificUrlPrefix () {
      if (this.countryCode === 'GB') {
        return 'uk'
      }
      return this.countrySpecificInformation?.content?.TrustpilotWidget?.[0]?.dataLocale?.slice(3) || 'www'
    }
  },
  mounted () {
    this.$nextTick(() => {
      const trustbox = this.$refs.trustpilotProductReviews
      window?.Trustpilot?.loadFromElement(trustbox)
    })
  }
}
